import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { dateFormat } from 'app/appSettings'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import { PdfSplittableTableRow } from 'app/views/forms/pdf-components/PdfSplittableTableRow'
import { PdfTableCell } from 'app/views/forms/pdf-components/PdfTableCell'
import { PdfTableHeaderCell } from 'app/views/forms/pdf-components/PdfTableHeaderCell'
import { PdfTableHeaderConfig, pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'
import { PdfUnsplittableTableRow } from 'app/views/forms/pdf-components/PdfUnsplittableTableRow'
import moment from 'moment'
import React from 'react'

const styles = StyleSheet.create({
  stageCol: {
    width: '10%',
    fontWeight: 'bold'
  },
  dateCol: {
    width: '10%'
  },
  textCol: {
    width: '35%'
  }
})

interface MilestonePhase {
  label?: Record<string, string>
  apiValue?: string
}

interface MilestoneValue {
  startDate?: string
  endDate?: string
  primaryActivities?: string
  comments?: string
}

interface FormMilestonesPdfTypeProps extends PdfTableHeaderConfig {
  /** Stages configured in the editor, matched with the value by index */
  phases?: MilestonePhase[]
}

interface FormMilestonesPdfProps {
  langVersion: string
  typeProps?: FormMilestonesPdfTypeProps
  value?: MilestoneValue[]
}

export const FormMilestonesPdf = ({
  value = [],
  langVersion,
  typeProps = {}
}: FormMilestonesPdfProps): React.ReactElement => {
  const { phases = [] } = typeProps

  const headerProps = { headerConfig: typeProps }

  return (
    <View style={pdfTableStyles.table}>
      <PdfUnsplittableTableRow>
        <PdfTableHeaderCell {...headerProps} style={styles.stageCol}>
          {i18n._(t`Stage`)}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell {...headerProps} style={styles.dateCol}>
          {i18n._(t`Start Date`)}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell {...headerProps} style={styles.dateCol}>
          {i18n._(t`End Date`)}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell {...headerProps} style={styles.textCol}>
          {i18n._(t`Primary Activities`)}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell {...headerProps} style={styles.textCol}>
          {i18n._(t`Comments`)}
        </PdfTableHeaderCell>
      </PdfUnsplittableTableRow>
      {phases
        .filter((phase, index) => value[index])
        .map((phase, index) => {
          const milestone = value[index]

          return (
            <PdfSplittableTableRow key={index}>
              <PdfTableCell style={styles.stageCol}>
                <Text>
                  {getLabelFromTranslationData({
                    data: phase.label,
                    langVersion
                  }) ||
                    (phase.apiValue && i18n._(phase.apiValue))}
                </Text>
              </PdfTableCell>
              <PdfTableCell style={styles.dateCol}>
                <Text>
                  {milestone.startDate && moment.utc(milestone.startDate).format(dateFormat)}
                </Text>
              </PdfTableCell>
              <PdfTableCell style={styles.dateCol}>
                <Text>{milestone.endDate && moment.utc(milestone.endDate).format(dateFormat)}</Text>
              </PdfTableCell>
              <PdfTableCell style={styles.textCol}>
                <Text>{milestone.primaryActivities}</Text>
              </PdfTableCell>
              <PdfTableCell style={styles.textCol}>
                <Text>{milestone.comments}</Text>
              </PdfTableCell>
            </PdfSplittableTableRow>
          )
        })}
    </View>
  )
}
